import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../../../__legacy__/models/error.model';
import { IMainApiService } from '../../../../../../../__legacy__/services/api.service';
import { IApiService } from '../../../../../../../__legacy__/services/api.service.base';

export interface IAddMarkingToolApiService {
  addMarkingToolAsync: (request: AddMarkingToolRequest) => Promise<void>;
}

export namespace IAddMarkingToolApiService {
  export const $: interfaces.ServiceIdentifier<IAddMarkingToolApiService> = Symbol('ADD_MARKING_TOOL_API_SERVICE');
}

@injectable()
export class AddMarkingToolRequest {
  projectId: string;
  annotationTypeId: string;
  name: string;
  color: string;
  selectorType: string;

  constructor(projectId: string, markingToolId: string, name: string, color: string, selectorType: string) {
    this.projectId = projectId;
    this.annotationTypeId = markingToolId;
    this.name = name;
    this.color = color;
    this.selectorType = selectorType;
  }
}

@injectable()
export class AddMarkingToolApiServiceImpl implements IAddMarkingToolApiService {
  constructor(@inject(IMainApiService.$) readonly apiService: IApiService) {}

  addMarkingToolAsync = async (request: AddMarkingToolRequest): Promise<void> => {
    const result = await this.apiService.postAsync('/AnnotationTypes/Add', request);

    if (result instanceof ACDLError) {
      throw result;
    }
  };
}
